module.exports = __webpack_public_path__ + "static/media/login_bg.d841fcd8.jpg";